import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

import ClockIcon from 'dibs-icons/exports/Clock';
import { PdpSharedLeadTime } from '../PdpSharedLeadTime/PdpSharedLeadTime';
import { PdpSharedBlurb } from '../PdpSharedBlurbs/PdpSharedBlurb/PdpSharedBlurb';

// helpers
import get from 'lodash.get';

// constants
import { ITEM_LEAD_TIME_AVAILABLE_NOW } from '../../constants/itemConstants';

export function PdpRespSidebarBlurbLeadTimeComponent({ item }) {
    const { isNewAndMadeToOrder } = item;
    const leadTimeUrlLabel = get(item, 'attributes.leadTime[0].option.urlLabel');
    const leadTime = get(item, 'attributes.leadTime[0].option.name');
    const isAvailableNow = leadTimeUrlLabel === ITEM_LEAD_TIME_AVAILABLE_NOW;
    // hide Lead Time if it doesn't return [TIME], for example 4 - 5 weeks
    // hide Lead Time if item is NOT isNewAndMadeToOrder
    if (!leadTimeUrlLabel || isAvailableNow || !isNewAndMadeToOrder) {
        return null;
    }

    return (
        <PdpSharedBlurb IconComponent={ClockIcon} dataTn="pdp-blurb-lead-time">
            <PdpSharedLeadTime leadTime={leadTime} />
        </PdpSharedBlurb>
    );
}

PdpRespSidebarBlurbLeadTimeComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const PdpRespSidebarBlurbLeadTime = createFragmentContainer(
    PdpRespSidebarBlurbLeadTimeComponent,
    {
        item: graphql`
            fragment PdpRespSidebarBlurbLeadTime_item on Item {
                isNewAndMadeToOrder
                attributes {
                    leadTime {
                        option {
                            name
                            urlLabel
                        }
                    }
                }
            }
        `,
    }
);
